module.exports = __webpack_public_path__ + "assets/img/ko-aa64f522.png";